import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setLoader } from "./MasterSlice";
import * as API from "../../utils/api.service";
import { TOAST_SUCCESS } from "../../utils/common.service";
import { data } from "jquery";

export const getTeacherListApiCall = createAsyncThunk("TeacherList", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        const { data: teacherList } = await API.getTeacherListApi(submitData);
        //  console.log("*********************************************",teacherList);
        dispatch(setLoader(false))
        return teacherList;
    } catch (error) {
        throw error;
    }
});

export const editTeacherDataApiCall = createAsyncThunk("editClientData", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        //console.log("000000000000000000000000000000000000",submitData);
        
        const { data: editTeacherData, code, message } = await API.updateTeacherApi(submitData);
        if (code === '1') {
            //TOAST_SUCCESS(message);
        }
        dispatch(setLoader(false))
        return { data: editTeacherData, code, message };
    } catch (error) {
        throw error;
    }
});

const initialState = {
    TeacherList: {
        data: [],
        error: null,
    },
    editTeacherData: {
        data: null,
        code: '',
        message: '',
        error: null,
    },
};

const teacherSlice = createSlice({
    name: "CLIENT",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getTeacherListApiCall.fulfilled, (state, action) => {
                state.TeacherList.data = action.payload;
            })
            .addCase(getTeacherListApiCall.rejected, (state, action) => {
                state.TeacherList.error = action.error.message;
            })
            .addCase(editTeacherDataApiCall.fulfilled, (state, action) => {
                const { message, code, data } = action.payload;
                state.editTeacherData.data = data;
                state.editTeacherData.message = message;
                state.editTeacherData.code = code;
            })
            .addCase(editTeacherDataApiCall.rejected, (state, action) => {
                state.editTeacherData.error = action.error.message;
            });
    },
});

export default teacherSlice.reducer;